<template>
    <div class="container">
        <div class="row">
            <div class="col-md-12">

                <div class="col-12 mt-4 mb-4 gifted-voucher">
                    <div class="card">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-md-6">
                                    <img class="img-fluid" v-bind:src="'/img/' + this.logo"  width="150" alt="Gifted PH" title="Gifted PH" />
                                </div>
                            </div>
                        </div>
                        <div class="card card-title text-center">
                            <h3>
                                PIN Request Page
                            </h3>
                        </div>
                        <div class="row p-3">
                            <div class="col-md-12">
                                <div class="card mb-2">
                                    <div class="card-body">
                                        <p class="font-italic">Please fill out this form. Your PIN will be send to your order email address.</p>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-body">
                                        <form id="pinRequestForm">
                                            <div class="form-row">
                                                <div class="form-group col-md-6">
                                                    <label for="mobile_number">Order Number</label>
                                                    <input type="text" class="form-control" id="order_number" name="order_number" />
                                                </div>

                                                <div class="form-group col-md-6">
                                                    <label for="mobile_number">Voucher Code</label>
                                                    <input type="text" class="form-control" id="voucher_code" name="voucher_code" />
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="form-group col-md-12"> All data is secure and will be processed according to Gifted.PH Data Privacy Standards. I have read the Privacy Policy.
                                                </div>
                                            </div>

                                            <input type="hidden" name="_token" id="token">
                                        </form>

                                        <div class="form-row">
                                            <div class="form-group col-md-12 text-center">
                                                <button type="button" @click="submitUser()" class="btn btn-success btn-lg" id="btn_submit">Send Request</button>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="card-footer">
                            <div class="row">
                                 <div class="col-md-12">
                                    <h2>Gifted. The Gift Giving Company</h2>
                                    <p>For more information, visit <a target="_blank" href="https://gifted.ph/">www.gifted.ph</a> or email us at <a href="mailto:admin@gifted.ph">admin@gifted.ph</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<style scoped>

</style>
<script>
    import axios from 'axios'

    export default {
        props: [],
        data(){
            return {
                order_number: "",
                voucher_code: "",
                logo: "gifted-logo-voucher.jpg",
            }
        },
        mounted() {

        },
        methods: {
            submitUser: () => {

                var order_number = $('#order_number').val();
                var voucher_code = $('#voucher_code').val();

                if(order_number == '' || voucher_code == ''){
                    Swal.fire({
                        icon: 'error',
                        title: 'Please fill up all the fields.'
                    })
                }
                else{
                    var token = $('meta[name="csrf-token"]').attr('content');
                        $('#token').val(token);
                        var formData = $('#pinRequestForm').serialize();
                        $.ajax({
                            type:'POST',
                            url:'/pin/submit',
                            data: formData,
                            dataType: 'JSON',
                            success: (result) => {
                            if(result)
                            {
                                if(result.status == 'error')
                                {
                                    Swal.fire({
                                        icon: 'error',
                                        title: result.message
                                    })
                                }
                                else{
                                    Swal.fire({
                                            icon: 'success',
                                            title: 'Thank you for your submission!',
                                            text: 'The PIN was sent to your order email address.',
                                            allowEscapeKey : false,
                                            allowOutsideClick: false,
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                window.location.reload();
                                            }
                                        })
                                }
                               
                            }
                            },
                            beforeSend: () => {
                                Swal.fire({
                                    title: 'Processing...',
                                    html: '<div class="spinner-grow" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                                    showConfirmButton: false,
                                    allowEscapeKey : false,
                                    allowOutsideClick: false,
                                });
                            }
                        });
                }
            }
        }
    }



</script>
